module.exports = __webpack_public_path__ + "img/x-icon.b67035c2.png";